import { RankingPageModule } from './ranking/ranking.module';
import { KpiModule } from 'src/app/components/kpi/kpi.module';
import { DesignSystemModule } from 'src/theme/design-system/design-system.module';
import { CardLabelsComponent } from './card-types/card-labels/card-labels.component';
import { ImplementationComponent } from './card-types/implementation/implementation.component';
import { AdvanceComponent } from './card-types/advance/advance.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { IndicatorPageRoutingModule } from './indicator-routing.module';

import { IndicatorPage } from './indicator.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    IndicatorPageRoutingModule,
    ComponentsModule,
    DesignSystemModule,
    KpiModule,
    RankingPageModule
  ],
  declarations: [IndicatorPage,AdvanceComponent,ImplementationComponent,CardLabelsComponent],
  exports:[AdvanceComponent,ImplementationComponent,CardLabelsComponent]
})
export class IndicatorPageModule {}
